// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_headerBackdrop__3aEMw {
  height: 62px;
}

.Header_header__OPd2N {
  position: sticky;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 62px;
  border-bottom: 1px solid #E2E2E2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Header_headerFixed__KrWFQ {
  position: fixed;
}
.Header_header__OPd2N:before {
  content: "";
  position: absolute;
  z-index: -10;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  -webkit-backdrop-filter: saturate(50%) blur(7px);
          backdrop-filter: saturate(50%) blur(7px);
}

.Header_tooltip__OwD\\+p {
  cursor: auto;
  display: flex;
  padding: 8px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 3px 1px 0px rgba(0, 0, 0, 0.04), 0px 3px 8px 0px rgba(0, 0, 0, 0.12);
}
.Header_tooltip__icon__aOmtF svg {
  width: 40px !important;
  height: 40px !important;
}
.Header_tooltip__description__lRb49 {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 332px;
}
.Header_tooltip__close__jlTpz {
  background: transparent;
  border: none;
  height: -moz-fit-content;
  height: fit-content;
  cursor: pointer;
}
.Header_tooltip__arrow__dWmOo {
  position: absolute;
  font-size: 7px;
  top: 0;
  left: 0;
  margin-top: -0.9em;
  width: 3em;
  height: 1em;
}
.Header_tooltip__arrow__dWmOo::before {
  content: "";
  margin: auto;
  display: block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 1em 1em 1em;
  border-color: transparent transparent white transparent;
}
.Header_tooltip__OwD\\+p > *:not(:last-child) {
  margin-right: 8px;
}

.Header_companyName__-uaUH {
  display: none;
  font-family: Roboto, serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  text-align: center;
  margin: 0 8px;
  color: #000000;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.Header_lang__xRlGG {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #4778EE;
  border: 0;
  background: none;
  cursor: pointer;
  margin: 0 24px;
}
.Header_lang__menu__jVh5b {
  z-index: 999;
}
.Header_lang__menu__content__GEbK\\+ {
  min-width: auto !important;
}
.Header_lang__menu__item__p1g8t {
  box-sizing: border-box;
  padding: 15px 10px 15px 0px !important;
  text-align: center;
  text-decoration: none;
  font-weight: 600;
}
.Header_lang__menu__item__active__cmLHJ {
  text-align: center !important;
  pointer-events: none;
}
.Header_lang__menu__item__active__cmLHJ > * {
  font-weight: 500;
  color: #4778EE !important;
}

.Header_logoWrapper__8eVd4 {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: content-box;
  width: 100px;
  height: 62px;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  margin-right: 24px;
}
.Header_logoWrapper__8eVd4 > * {
  -webkit-user-select: none;
          user-select: none;
}
.Header_logoWrapper__8eVd4:after {
  content: "";
  display: block;
  width: 1px;
  height: 50%;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: #E2E2E2;
}

.Header_user__Aw9iD {
  height: 62px;
  width: 62px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.Header_menu__DMnVX {
  width: 160px;
  z-index: 1050;
}

.Header_logout__z5OQw {
  color: #E23834 !important;
}

.Header_navLink__czme9 {
  user-select: none;
  text-decoration: none;
  -webkit-user-select: none;
  -webkit-user-drag: none;
  -webkit-app-region: no-drag;
}

.Header_group__y6oFi {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.Header_actions__yz-er {
  display: flex;
  align-items: center;
}

.Header_help__ybnbJ {
  margin-left: 24px;
}

.Header_createCompanyButton__iiksN {
  border-color: #4778EE !important;
  border-radius: 8px !important;
  font-size: 15px !important;
  font-weight: 500;
}

.Header_createOffer__button__20mMt {
  cursor: pointer;
  font-size: 15px !important;
  font-weight: 500;
  box-shadow: 0 49px 20px rgba(71, 120, 238, 0.01), 0 28px 17px rgba(71, 120, 238, 0.05), 0 12px 12px rgba(71, 120, 238, 0.09), 0 3px 7px rgba(71, 120, 238, 0.1), 0 0 0 rgba(71, 120, 238, 0.1) !important;
}
.Header_createOffer__button__text__LDcEt {
  margin-left: 4px;
}
.Header_createOffer__menu__4X2hV {
  z-index: 999;
  width: 202px;
}

.Header_companySelect__desktop__HAPhB {
  margin-right: 5px;
}

.Header_companyMenu__description__LMHz1 {
  margin-top: 7px;
  margin-bottom: 2px;
}
.Header_companyMenu__description__label__5E39A {
  padding-left: 2px !important;
}
.Header_companyMenu__edit__kAQ1b {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 40px;
  width: 30px;
  padding-right: 8px;
  margin-left: auto;
  cursor: pointer !important;
}
.Header_companyMenu__edit__kAQ1b:hover path {
  fill: #4778ee;
}
.Header_companyMenu__item__auyjg {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  width: 100%;
  display: flex;
  align-items: center;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
  color: #272A36;
  padding-left: 8px;
  margin-bottom: 8px;
  max-width: 100%;
}
.Header_companyMenu__item__name__otJ8K {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #272A36;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.Header_companyMenu__item__role__BszHo {
  font-size: 9px;
  line-height: 11px;
  color: #8E8E93;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.Header_companyMenu__item__info__tBHEY {
  margin-left: 8px;
  max-width: 100%;
  overflow: hidden;
}
.Header_companyMenu__item__auyjg:hover {
  background: #F0F4FE;
  color: #4778EE;
}
.Header_companyMenu__itemActive__rJf6l {
  background: #F0F4FE;
  cursor: default;
}
.Header_companyMenu__itemActive__rJf6l .Header_companyMenu__title__4H17M {
  color: #4778EE;
}
.Header_companyMenu__add__cozc9 {
  padding-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Roboto, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #4778EE;
  height: 32px;
  cursor: pointer;
}
.Header_companyMenu__content__WogoF {
  padding: 16px;
  padding-top: 0;
  width: 199px;
  border-radius: 28px !important;
}
.Header_companyMenu__margin__C\\+-Fy {
  padding: 0 16px 8px;
}
.Header_companyMenu__logo__0AZam {
  width: 24px;
  height: 24px;
  background: #EBECF2;
  border-radius: 4px;
  flex-shrink: 0;
}
.Header_companyMenu__logoImg__JkK2k {
  width: 24px;
  height: 24px;
}
.Header_companyMenu__title__4H17M {
  font-family: Roboto, serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0;
  text-align: left;
  color: #272A36;
  margin-right: 8px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  margin-left: 8px;
}
.Header_companyMenu__label__P\\+v80 {
  width: 100%;
}
.Header_companyMenu__open__nwl7E {
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  cursor: pointer;
  align-items: center;
  transition: 0.2s background;
  border-radius: 12px;
  padding: 8px;
  background: #F0F4FE;
}
.Header_companyMenu__open__info__S1a-u {
  margin-left: 8px;
  width: 108px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.Header_companyMenu__open__name__Bzj9n {
  max-width: 100%;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #272A36;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Header_companyMenu__open__manage__1oXJm {
  border: 0;
  background: 0;
  display: inline-block;
  color: #4778EE;
  font-weight: 600;
  font-size: 11px;
  line-height: 13px;
  cursor: pointer;
  transition: 0.2s all;
  max-width: 100%;
  -webkit-user-select: none;
          user-select: none;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Header_companyMenu__open__manage__1oXJm:hover {
  color: #0b48dc;
}
.Header_companyMenu__icon__PaUQQ {
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(180deg);
  width: 16px;
  height: 16px;
  margin-left: 4px;
  transition: 0.2s all;
}
.Header_companyMenu__iconOpen__xVZhF {
  transform: rotate(0deg);
}

.Header_button__icon__SmeQ0 {
  margin-right: 14px;
}

.Header_hamburger__XTkWZ {
  width: 56px;
  height: 100%;
  border: 0;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 19px;
  position: relative;
}
.Header_hamburger__line__eeNgC {
  background: black;
  border-radius: 3px;
  width: 18px;
  height: 1.5px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  transition: 0.3s all;
}
.Header_hamburger__line__eeNgC:first-child {
  top: calc(50% - 4.5px - 0.75px);
}
.Header_hamburger__line__eeNgC:nth-child(2) {
  opacity: 1;
  top: calc(50% - 0.75px);
}
.Header_hamburger__line__eeNgC:last-child {
  top: calc(50% + 4.5px - 0.75px);
}
.Header_hamburgerActive__1i67O .Header_hamburger__line__eeNgC:first-child {
  top: calc(50% - 0.75px);
  transform: translateX(-50%) rotate(45deg);
}
.Header_hamburgerActive__1i67O .Header_hamburger__line__eeNgC:nth-child(2) {
  background: white;
  opacity: 0;
}
.Header_hamburgerActive__1i67O .Header_hamburger__line__eeNgC:last-child {
  top: calc(50% - 0.75px);
  transform: translateX(-50%) rotate(-45deg);
}

.Header_avatar__3dTxt {
  min-width: 24px;
}

.Header_avatarHeader__NGLvW {
  min-width: 24px;
}

.Header_spacer__\\+LEVB {
  margin: auto;
}

.Header_socialLink__lBrk0 {
  height: 24px;
  width: 24px;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F0F4FE;
  border-radius: 50%;
  transition: background 0.3s;
}
.Header_socialLink__lBrk0:hover {
  background: #4778EE;
}
.Header_socialLink__lBrk0:hover svg path {
  fill: #fff;
  transition: fill 0.3s;
}
.Header_socialLink__lBrk0 + .Header_socialLink__lBrk0 {
  margin-left: 10px;
}

@media (max-width: 1065px) {
  .Header_socialLink__lBrk0 {
    display: none;
  }
}
@media (max-width: 700px) {
  .Header_companyName__-uaUH {
    display: -webkit-box;
  }
  .Header_langBlock__feymz {
    display: none;
  }
  .Header_lang__menu__jVh5b,
  .Header_companyMenu__list__FsyCg {
    position: fixed !important;
  }
  .Header_socialLink__lBrk0 {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/HomeLayout/Header/Header.module.scss","webpack://./src/components/layouts/HomeLayout/config.module.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;AAKF;;AAFA;EACE,gBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,YCRc;EDSd,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAKF;AAHE;EACE,eAAA;AAKJ;AAFE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EAEA,oCAAA;EACA,gDAAA;UAAA,wCAAA;AAGJ;;AACA;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,oFAAA;AAEF;AACI;EACE,sBAAA;EACA,uBAAA;AACN;AAGE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AADJ;AAIE;EACE,uBAAA;EACA,YAAA;EACA,wBAAA;EAAA,mBAAA;EACA,eAAA;AAFJ;AAKE;EACE,kBAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AAHJ;AAII;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,uDAAA;AAFN;AAME;EACE,iBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4BAAA;AALF;;AAQA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AALF;AAOE;EACE,YAAA;AALJ;AAOI;EACE,0BAAA;AALN;AAQI;EACE,sBAAA;EACA,sCAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AANN;AAQM;EACE,6BAAA;EACA,oBAAA;AANR;AAQQ;EACE,gBAAA;EACA,yBAAA;AANV;;AAcA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YC1JwB;ED2JxB,YCzJc;ED0Jd,yBAAA;UAAA,iBAAA;EACA,cAAA;EACA,kBAAA;AAXF;AAaE;EACE,yBAAA;UAAA,iBAAA;AAXJ;AAcE;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,yBAAA;AAZJ;;AAgBA;EACE,YChLc;EDiLd,WCjLc;EDkLd,oBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,uBAAA;EACA,SAAA;EAEA,eAAA;AAfF;;AAkBA;EACE,YAAA;EACA,aAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;AAfF;;AAkBA;EACE,aAAA;EACA,oBAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;AAfF;;AAsBA;EACE,iBAAA;AAnBF;;AAsBA;EACE,gCAAA;EACA,6BAAA;EACA,0BAAA;EACA,gBAAA;AAnBF;;AAuBE;EACE,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,yMAAA;AApBJ;AA0BI;EACE,gBAAA;AAxBN;AA4BE;EACE,YAAA;EACA,YAAA;AA1BJ;;AA8BA;EACE,iBAAA;AA3BF;;AA+BE;EACE,eAAA;EACA,kBAAA;AA5BJ;AA8BI;EACE,4BAAA;AA5BN;AAgCE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;AA9BJ;AAgCI;EACE,aAAA;AA9BN;AAkCE;EACE,yBAAA;EACA,4BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAhCJ;AAkCI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EAEA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAjCN;AAoCI;EACE,cAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EAEA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAnCN;AAsCI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;AApCN;AAuCI;EACE,mBAAA;EACA,cAAA;AArCN;AAwCI;EACE,mBAAA;EACA,eAAA;AAtCN;AAwCM;EACE,cAAA;AAtCR;AA2CE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AAzCJ;AA4CE;EACE,aAAA;EACA,cAAA;EACA,YAAA;EACA,8BAAA;AA1CJ;AA6CE;EACE,mBAAA;AA3CJ;AA8CE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AA5CJ;AA8CI;EACE,WAAA;EACA,YAAA;AA5CN;AAgDE;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4BAAA;EACA,oBAAA;EACA,gBAAA;AA9CJ;AAiDE;EACE,WAAA;AA/CJ;AAkDE;EACE,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AAhDJ;AAkDI;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAhDN;AAmDI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,kBAAA;EACA,uBAAA;EACA,mBAAA;AAlDN;AAqDI;EACE,SAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,kBAAA;EACA,uBAAA;EACA,mBAAA;AApDN;AAsDM;EACE,cAAA;AApDR;AAyDE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;AAvDJ;AAyDI;EACE,uBAAA;AAvDN;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EAIE,WAAA;EACA,YAAA;EAEA,SAAA;EACA,uBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AA9DF;AAgEE;EACE,iBAAA;EACA,kBAAA;EACA,WAnBW;EAoBX,aAnBY;EAqBZ,kBAAA;EACA,SAAA;EACA,2BAAA;EAEA,oBAAA;AAhEJ;AAkEI;EACE,+BAAA;AAhEN;AAmEI;EACE,UAAA;EACA,uBAAA;AAjEN;AAoEI;EACE,+BAAA;AAlEN;AAuEI;EACE,uBAAA;EACA,yCAAA;AArEN;AAwEI;EACE,iBAAA;EACA,UAAA;AAtEN;AAyEI;EACE,uBAAA;EACA,0CAAA;AAvEN;;AA4EA;EACE,eAAA;AAzEF;;AA4EA;EACE,eAAA;AAzEF;;AA4EA;EACE,YAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;AAzEF;AA2EE;EACE,mBAAA;AAzEJ;AA2EI;EACE,UAAA;EACA,qBAAA;AAzEN;AA6EE;EACE,iBAAA;AA3EJ;;AA+EA;EACE;IACE,aAAA;EA5EF;AACF;AA+EA;EACE;IACE,oBAAA;EA7EF;EAgFA;IACE,aAAA;EA9EF;EAiFA;;IAEE,0BAAA;EA/EF;EAkFA;IACE,aAAA;EAhFF;AACF","sourcesContent":["@import '../config.module';\n\n.headerBackdrop {\n  height: $header-height;\n}\n\n.header {\n  position: sticky;\n  top: 0;\n  z-index: 999;\n  width: 100%;\n  height: $header-height;\n  border-bottom: 1px solid #E2E2E2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  &Fixed {\n    position: fixed;\n  }\n\n  &:before {\n    content: '';\n    position: absolute;\n    z-index: -10;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n\n    background: rgba(255, 255, 255, 0.8);\n    backdrop-filter: saturate(50%) blur(7px);\n  }\n}\n\n.tooltip {\n  cursor: auto;\n  display: flex;\n  padding: 8px;\n  border-radius: 8px;\n  background-color: #fff;\n  box-shadow: 0px 3px 1px 0px rgba(0, 0, 0, 0.04), 0px 3px 8px 0px rgba(0, 0, 0, 0.12);\n\n  &__icon {\n    & svg {\n      width: 40px !important;\n      height: 40px !important;\n    }\n  }\n\n  &__description {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    width: 332px\n  }\n\n  &__close {\n    background: transparent;\n    border: none;\n    height: fit-content;\n    cursor: pointer;\n  }\n\n  &__arrow {\n    position: absolute;\n    font-size: 7px;\n    top: 0;\n    left: 0;\n    margin-top: -0.9em;\n    width: 3em;\n    height: 1em;\n    &::before {\n      content: \"\";\n      margin: auto;\n      display: block;\n      width: 0;\n      height: 0;\n      border-style: solid;\n      border-width: 0 1em 1em 1em;\n      border-color: transparent transparent white transparent;\n    }\n  }\n\n  & > *:not(:last-child) {\n    margin-right: 8px;\n  }\n}\n\n.companyName {\n  display: none;\n  font-family: Roboto, serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: 0;\n  text-align: center;\n  margin: 0 8px;\n  color: #000000;\n  word-break: break-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n}\n\n.lang {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n  color: #4778EE;\n  border: 0;\n  background: none;\n  cursor: pointer;\n  margin: 0 24px;\n\n  &__menu {\n    z-index: 999;\n\n    &__content {\n      min-width: auto !important;\n    }\n\n    &__item {\n      box-sizing: border-box;\n      padding: 15px 10px 15px 0px !important;\n      text-align: center;\n      text-decoration: none;\n      font-weight: 600;\n\n      &__active {\n        text-align: center !important;\n        pointer-events: none;\n\n        & > * {\n          font-weight: 500;\n          color: #4778EE !important;\n        }\n      }\n    }\n  }\n}\n\n\n.logoWrapper {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: content-box;\n  width: $sidebar-collapsed-width;\n  height: $header-height;\n  user-select: none;\n  flex-shrink: 0;\n  margin-right: 24px;\n\n  & > * {\n    user-select: none;\n  }\n\n  &:after {\n    content: '';\n    display: block;\n    width: 1px;\n    height: 50%;\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: #E2E2E2;\n  }\n}\n\n.user {\n  height: $header-height;\n  width: $header-height;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  background: transparent;\n  border: 0;\n\n  cursor: pointer;\n}\n\n.menu {\n  width: 160px;\n  z-index: 1050;\n}\n\n.logout {\n  color: #E23834 !important;\n}\n\n.navLink {\n  user-select: none;\n  text-decoration: none;\n  -webkit-user-select: none;\n  -webkit-user-drag: none;\n  -webkit-app-region: no-drag;\n}\n\n.group {\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n\n  //& > :not(:first-child) {\n  //  margin-left: 24px !important;\n  //}\n}\n\n.help {\n  margin-left: 24px;\n}\n\n.createCompanyButton {\n  border-color: #4778EE !important;\n  border-radius: 8px !important;\n  font-size: 15px !important;\n  font-weight: 500;\n}\n\n.createOffer {\n  &__button {\n    cursor: pointer;\n    font-size: 15px !important;\n    font-weight: 500;\n    box-shadow: 0 49px 20px rgba(71, 120, 238, 0.01),\n    0 28px 17px rgba(71, 120, 238, 0.05),\n    0 12px 12px rgba(71, 120, 238, 0.09),\n    0 3px 7px rgba(71, 120, 238, 0.1),\n    0 0 0 rgba(71, 120, 238, 0.1) !important;\n\n    &__text {\n      margin-left: 4px;\n    }\n  }\n\n  &__menu {\n    z-index: 999;\n    width: 202px;\n  }\n}\n\n.companySelect__desktop {\n  margin-right: 5px;\n}\n\n.companyMenu {\n  &__description {\n    margin-top: 7px;\n    margin-bottom: 2px;\n\n    &__label {\n      padding-left: 2px !important;\n    }\n  }\n\n  &__edit {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    height: 40px;\n    width: 30px;\n    padding-right: 8px;\n    margin-left: auto;\n    cursor: pointer !important;\n\n    &:hover path {\n      fill: #4778ee;\n    }\n  }\n\n  &__item {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    height: 40px;\n    border-radius: 12px;\n    cursor: pointer;\n    color: #272A36;\n    padding-left: 8px;\n    margin-bottom: 8px;\n    max-width: 100%;\n\n    &__name {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 14px;\n      color: #272A36;\n      max-width: 100%;\n\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n\n    &__role {\n      font-size: 9px;\n      line-height: 11px;\n      color: #8E8E93;\n      max-width: 100%;\n\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n\n    &__info {\n      margin-left: 8px;\n      max-width: 100%;\n      overflow: hidden;\n    }\n\n    &:hover {\n      background: #F0F4FE;\n      color: #4778EE;\n    }\n\n    &Active {\n      background: #F0F4FE;\n      cursor: default;\n\n      .companyMenu__title {\n        color: #4778EE;\n      }\n    }\n  }\n\n  &__add {\n    padding-bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: Roboto, serif;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 14px;\n    text-align: center;\n    color: #4778EE;\n    height: 32px;\n    cursor: pointer;\n  }\n\n  &__content {\n    padding: 16px;\n    padding-top: 0;\n    width: 199px;\n    border-radius: 28px !important;\n  }\n\n  &__margin {\n    padding: 0 16px 8px;\n  }\n\n  &__logo {\n    width: 24px;\n    height: 24px;\n    background: #EBECF2;\n    border-radius: 4px;\n    flex-shrink: 0;\n\n    &Img {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  &__title {\n    font-family: Roboto, serif;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 14px;\n    letter-spacing: 0;\n    text-align: left;\n    color: #272A36;\n    margin-right: 8px;\n    word-break: break-all;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    display: -webkit-box;\n    margin-left: 8px;\n  }\n\n  &__label {\n    width: 100%;\n  }\n\n  &__open {\n    user-select: none;\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n    transition: 0.2s background;\n    border-radius: 12px;\n    padding: 8px;\n    background: #F0F4FE;\n\n    &__info {\n      margin-left: 8px;\n      width: 108px;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    &__name {\n      max-width: 100%;\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 14px;\n      color: #272A36;\n\n      overflow-x: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    &__manage {\n      border: 0;\n      background: 0;\n      display: inline-block;\n      color: #4778EE;\n      font-weight: 600;\n      font-size: 11px;\n      line-height: 13px;\n      cursor: pointer;\n      transition: 0.2s all;\n      max-width: 100%;\n      user-select: none;\n\n      overflow-x: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n\n      &:hover {\n        color: #0b48dc;\n      }\n    }\n  }\n\n  &__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transform: rotate(180deg);\n    width: 16px;\n    height: 16px;\n    margin-left: 4px;\n    transition: 0.2s all;\n\n    &Open {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n.button__icon {\n  margin-right: 14px;\n}\n\n.hamburger {\n  $line-width: 18px;\n  $line-height: 1.5px;\n\n  width: 56px;\n  height: 100%;\n\n  border: 0;\n  background: transparent;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0 19px;\n  position: relative;\n\n  &__line {\n    background: black;\n    border-radius: 3px;\n    width: $line-width;\n    height: $line-height;\n\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n\n    transition: 0.3s all;\n\n    &:first-child {\n      top: calc(50% - $line-height * 3 - $line-height / 2);\n    }\n\n    &:nth-child(2) {\n      opacity: 1;\n      top: calc(50% - $line-height / 2);\n    }\n\n    &:last-child {\n      top: calc(50% + $line-height * 3 - $line-height / 2);\n    }\n  }\n\n  &Active {\n    .hamburger__line:first-child {\n      top: calc(50% - $line-height / 2);\n      transform: translateX(-50%) rotate(45deg); // translateY(#{($line-width - $line-height * 4) / 4});\n    }\n\n    .hamburger__line:nth-child(2) {\n      background: white;\n      opacity: 0;\n    }\n\n    .hamburger__line:last-child {\n      top: calc(50% - $line-height / 2);\n      transform: translateX(-50%) rotate(-45deg); // translateY(#{($line-width - $line-height * 4) / -4});\n    }\n  }\n}\n\n.avatar {\n  min-width: 24px;\n}\n\n.avatarHeader {\n  min-width: 24px;\n}\n\n.spacer {\n  margin: auto;\n}\n\n.socialLink {\n  height: 24px;\n  width: 24px;\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #F0F4FE;\n  border-radius: 50%;\n  transition: background .3s;\n\n  &:hover {\n    background: #4778EE;\n\n    svg path {\n      fill: #fff;\n      transition: fill .3s;\n    }\n  }\n\n  & + & {\n    margin-left: 10px;\n  }\n}\n\n@media (max-width: 1065px) {\n  .socialLink {\n    display: none;\n  }\n}\n\n@media (max-width: 700px) {\n  .companyName {\n    display: -webkit-box;\n  }\n\n  .langBlock {\n    display: none;\n  }\n\n  .lang__menu,\n  .companyMenu__list {\n    position: fixed !important;\n  }\n\n  .socialLink {\n    display: flex;\n  }\n}\n","$sidebar-width: 334px;\n$sidebar-collapsed-width: 100px;\n\n$header-height: 62px;\n\n\n// max width on which should be visible mobile sidebar\n$mobile-sidebar-breakpoint-width: 700px;\n\n:export {\n  sidebarWidth: $sidebar-width;\n  sidebarWidthCollapsed: $sidebar-collapsed-width;\n\n  mobileSidebarBreakpointWidth: $mobile-sidebar-breakpoint-width;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarWidth": `334px`,
	"sidebarWidthCollapsed": `100px`,
	"mobileSidebarBreakpointWidth": `700px`,
	"headerBackdrop": `Header_headerBackdrop__3aEMw`,
	"header": `Header_header__OPd2N`,
	"headerFixed": `Header_headerFixed__KrWFQ`,
	"tooltip": `Header_tooltip__OwD+p`,
	"tooltip__icon": `Header_tooltip__icon__aOmtF`,
	"tooltip__description": `Header_tooltip__description__lRb49`,
	"tooltip__close": `Header_tooltip__close__jlTpz`,
	"tooltip__arrow": `Header_tooltip__arrow__dWmOo`,
	"companyName": `Header_companyName__-uaUH`,
	"lang": `Header_lang__xRlGG`,
	"lang__menu": `Header_lang__menu__jVh5b`,
	"lang__menu__content": `Header_lang__menu__content__GEbK+`,
	"lang__menu__item": `Header_lang__menu__item__p1g8t`,
	"lang__menu__item__active": `Header_lang__menu__item__active__cmLHJ`,
	"logoWrapper": `Header_logoWrapper__8eVd4`,
	"user": `Header_user__Aw9iD`,
	"menu": `Header_menu__DMnVX`,
	"logout": `Header_logout__z5OQw`,
	"navLink": `Header_navLink__czme9`,
	"group": `Header_group__y6oFi`,
	"actions": `Header_actions__yz-er`,
	"help": `Header_help__ybnbJ`,
	"createCompanyButton": `Header_createCompanyButton__iiksN`,
	"createOffer__button": `Header_createOffer__button__20mMt`,
	"createOffer__button__text": `Header_createOffer__button__text__LDcEt`,
	"createOffer__menu": `Header_createOffer__menu__4X2hV`,
	"companySelect__desktop": `Header_companySelect__desktop__HAPhB`,
	"companyMenu__description": `Header_companyMenu__description__LMHz1`,
	"companyMenu__description__label": `Header_companyMenu__description__label__5E39A`,
	"companyMenu__edit": `Header_companyMenu__edit__kAQ1b`,
	"companyMenu__item": `Header_companyMenu__item__auyjg`,
	"companyMenu__item__name": `Header_companyMenu__item__name__otJ8K`,
	"companyMenu__item__role": `Header_companyMenu__item__role__BszHo`,
	"companyMenu__item__info": `Header_companyMenu__item__info__tBHEY`,
	"companyMenu__itemActive": `Header_companyMenu__itemActive__rJf6l`,
	"companyMenu__title": `Header_companyMenu__title__4H17M`,
	"companyMenu__add": `Header_companyMenu__add__cozc9`,
	"companyMenu__content": `Header_companyMenu__content__WogoF`,
	"companyMenu__margin": `Header_companyMenu__margin__C+-Fy`,
	"companyMenu__logo": `Header_companyMenu__logo__0AZam`,
	"companyMenu__logoImg": `Header_companyMenu__logoImg__JkK2k`,
	"companyMenu__label": `Header_companyMenu__label__P+v80`,
	"companyMenu__open": `Header_companyMenu__open__nwl7E`,
	"companyMenu__open__info": `Header_companyMenu__open__info__S1a-u`,
	"companyMenu__open__name": `Header_companyMenu__open__name__Bzj9n`,
	"companyMenu__open__manage": `Header_companyMenu__open__manage__1oXJm`,
	"companyMenu__icon": `Header_companyMenu__icon__PaUQQ`,
	"companyMenu__iconOpen": `Header_companyMenu__iconOpen__xVZhF`,
	"button__icon": `Header_button__icon__SmeQ0`,
	"hamburger": `Header_hamburger__XTkWZ`,
	"hamburger__line": `Header_hamburger__line__eeNgC`,
	"hamburgerActive": `Header_hamburgerActive__1i67O`,
	"avatar": `Header_avatar__3dTxt`,
	"avatarHeader": `Header_avatarHeader__NGLvW`,
	"spacer": `Header_spacer__+LEVB`,
	"socialLink": `Header_socialLink__lBrk0`,
	"langBlock": `Header_langBlock__feymz`,
	"companyMenu__list": `Header_companyMenu__list__FsyCg`
};
export default ___CSS_LOADER_EXPORT___;
